import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { RoomCoolingIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const ElectricRoomCoolingDeviceForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_ROOM_COOLING_DEVICE>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<RoomCoolingIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gerät zur Raumkühlung
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricRoomCoolingDevice.value.yes}
                        onChange={ev =>
                            setValues(values => {
                                values.newConnectionElectricRoomCoolingDevice.value = {
                                    yes: ev.target.checked,
                                    no: !ev.target.checked,
                                };
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricRoomCoolingDevice.value.yes}
                detail={
                    <p className={classes.p}>
                        Nachdem Sie diesen Antrag für Ihren Neuanschluss abgesendet haben, erfassen Sie bitte einen weiteren 
                        Antrag über den Prozess "Verbrauchsgeräte, z.B. Ladeeinrichtung, Wärmepumpe, Gerät zur Raumkühlung".
                    </p>
                }
            />
        </Fragment>
    );
};
